import React, { Component } from 'react';
import '../../assets/scss/style.scss';
import data from '../../json/regisComp.json';

class Instruction extends Component {
    render() {
        return(
            <div className="container">
              <h3>Step 1 : About Workshop</h3>
              <hr/>
              Requirement: <br/>
                <li>Participants must be an active full-time undergraduate student from any major</li>
                <li>Participants must have basic programming knowledge</li>
                <li>Participants must have basic skill in python programming</li>
                <li>Each Participant has AWS Educate account which participants can register on <a href="https://aws.amazon.com/education/awseducate" target="_blank" className="green"><b>aws.amazon.com/education/awseducate</b></a></li>
                <li>Each participant must be register on <b>impulseitb.com</b></li>
                <li>Participants must upload a video about motivations / reasons for joining Impulse Workshop and upload them on verification</li>
                <li>Participant must share poster of impulse workshop on <a href="https://bit.ly/ImpulseWorkshop" target="_blank" className="green"><b>bit.ly/ImpulseWorkshop</b></a> to Instagram story or minimum one social media group that consist of university student</li>
              <br/>
              <h5 className="ml-4 mt-5 green">Register Your Team!</h5>
                <p className="ml-4 mb-0"><b>Free Registration</b> for opening workshop and self-paced learning</p>
                <p className="ml-4">For Main Workshop and Project Challenge there will be registration fee of <b>Rp150.000/Person</b></p>
              {/* <p>Are you willing to follow all the provisions that apply to this workshop?</p> */}
              {/* checkbox */}
              <button className="btn btn-primary btn-block mt-3 shadow-sm" onClick={this.props.nextStep}>Selanjutnya</button>
            </div>
        )
    }
}

export default Instruction;
